import {
  ECategory,
} from '../../../../repositories/infrastructure-caching/entities/infrastructure/CategoryItemsSchema';

import { SchoolIcon } from './school';
import { KindergardenIcon } from './kindergarden';
import { PolyclinicsIcon } from './polyclinics';
import { GroceryStoreIcon } from './grocery-store';

export const getIconComponent = (category: ECategory): typeof SchoolIcon | void => {
  // tslint:disable-next-line: no-any
  const icons: any = {
    [ECategory.School]: SchoolIcon,
    [ECategory.Nursery]: KindergardenIcon,
    [ECategory.Clinic]: PolyclinicsIcon,
    [ECategory.Grocery]: GroceryStoreIcon,
  };

  return icons[category];
};

export {
  SchoolIcon,
  KindergardenIcon,
  PolyclinicsIcon,
  GroceryStoreIcon,
};
